<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <form id="form-edit-compliance" v-on:submit.prevent="validateSubmit">
                    <div class="form-group">
                        <ejs-textbox v-model="data.titulo" placeholder="Titulo:" data-msg-containerid="formUsersError2"></ejs-textbox>
                    </div>
                    <div class="form-group">
                        <ejs-dropdownlist v-model="data.relevancia" :dataSource="relevancia" placeholder="Relevancia:"></ejs-dropdownlist>
                    </div>
                    <div class="form-group">
                        <ejs-dropdownlist v-model="data.periodicidad" :dataSource="periodicidad" placeholder="Periodicidad:"></ejs-dropdownlist>
                    </div>
                    <div class="form-group" v-show="data.periodicidad == 'Periodico'">
                        <ejs-dropdownlist 
                            v-model="data.periodo" 
                            placeholder="Periodo:"
                            :dataSource="listPeriodicidad" 
                            :showClearButton="true"
                            :showDropDownIcon="true"
                            :fields="{ text: 'label', value: 'value' }"
                        />
                    </div>
                    <div class="form-group">
                        <ejs-textbox :multiline="true" v-model="data.descripcion" placeholder="Descripcion:"></ejs-textbox>
                    </div>
                    <div class="row" v-if="data.periodicidad != 'Permanente'">
                        <div class="col-6" v-for="(d, k) in data.fechas">
                            <div class="form-group" >
                                <ejs-datepicker 
                                    v-model="d.fecha_cumplimiento" 
                                    start='Decade' 
                                    :placeholder="'Fecha cumplimiento ' +(k + 1)+ ':'" 
                                    required="required"
                                    :format="'yyyy-MM-dd'"
                                />
                                <button type="button" class="btn btn-sm btn-danger" v-if="data.periodicidad == 'Periodico' && data.fechas.length > 1" v-on:click="deleteDate(k)">X</button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="data.periodicidad == 'Periodico'">
                        <button type="button" class="btn btn-sm e-btn e-info" style="text-transform: none !important;" v-on:click="addDate()">Añadir fechas</button>
                    </div>
                    <div class="form-group" v-show="['Unica Vez', 'Periodico'].includes(data.periodicidad) && !showReportingAuthorityName">
                        <ejs-dropdownlist 
                            id="reporting-authority"
                            name="reportingAuthority"
                            placeholder="Ante quién se ejecuta:"
                            v-model="data.reporting_authority_id" 
                            :allowFiltering="true" 
                            :enableVirtualization="true"
                            :dataSource="reportingAuthorities" 
                            :fields="{ text: 'name', value: 'id' }"
                            :filterBarPlaceholder="'Buscar autoridad...'"
                            :noRecordsTemplate="'No se encontraron autoridades'"
                            :filterType="'Contains'"
                        />
                        <div class="text-muted" style="font-size: 0.8em;">
                            Si no se encuentra la autoridad, haz clic <span class="text-primary" style="cursor: pointer;" v-on:click="showReportingAuthorityName = true">aquí</span> para crearla.
                        </div>
                    </div>
                    <div class="form-group" v-show="showReportingAuthorityName">
                        <div class="text-muted" style="font-size: 0.8em;">
                            Para volver a la lista haz clic <span class="text-primary" style="cursor: pointer;" v-on:click="showReportingAuthorityName = false">aquí</span>.
                        </div>
                        <ejs-textbox 
                            name="Nombre de la autoridad" 
                            v-model="reportingAuthorityName" 
                            placeholder="Nombre de la autoridad:" 
                            data-msg-containerid="reportingAuthorityName"
                            :showClearButton="true"
                        />
                        <div id="reportingAuthorityName"></div>
                        <ejs-checkbox 
                            label="Marcar como pública (visible para todos los tenants)" 
                            name="status"
                            v-model="isPublicReportingAuthority"
                            :checked="isPublicReportingAuthority"
                        />
                    </div>
                    <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtnFormUsers" :disabled="disabledButton">Guardar</ejs-progressbutton>
                </form>
            </div>
        </div>
            


        <div class="row  mt-4 justify-content-center">
            <div class="col-12 col-lg-6 mb-3">
                <h3>Normas</h3>
            </div> 
            <div class="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-end align-items-end">
                <button type="button" class="e-control e-btn e-lib e-success" data-ripple="true" v-on:click="onAddRule(data)">
                    Asociar Norma
                </button>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <table class="table bg-light border">
                    <thead>
                        <tr class="e-columnheader">
                            <th class="text-secondary" >TITULO</th>
                            <th class="text-secondary" >OPCIONES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="d in data.normas">
                            <td>{{d.titulo}}</td>
                            <td>
                                <div class="text-center">
                                    <a v-on:click="onRuleEdit(d)" class="btn btn-sm btn-primary">Actualizar</a>
                                    <a v-on:click="onUnpin(d)" class="btn btn-sm e-btn e-primary" style="text-transform: none !important;">Desasociar</a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </div>

        </div>

        <div class="row  mt-4 justify-content-center">
            <form id="send-notification" v-on:submit.prevent="alertSubmit">
                <div class="col-12 col-lg-12 mb-3">
                    <h3>Envio de notificación a usuarios</h3>
                </div> 
                
                    <div class="form-group">
                        <div class="control-section">
                            <div class="sample-container">
                                <div class="default-section">
                                    <ejs-richtexteditor v-model="content"  ref="defaultRTE" :height="400" :value="content" ></ejs-richtexteditor>
                                </div>
                            </div>
                        </div>
                    </div>
                
                <ejs-progressbutton type='submit' cssClass="e-primary" :disabled="disabledButton2">Enviar</ejs-progressbutton>
            </form>
        </div>

    </div>
</template>
<script>
import axios from "axios";
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar } from "@syncfusion/ej2-vue-richtexteditor";

Vue.use(RichTextEditorPlugin);
Vue.use(ProgressButtonPlugin);

export default {
  name: "edit-compliance",
  props: ["data"],
  provide: {
        richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar]
    },
  data() {
    return {
        listPeriodicidad: [],
        fieldPeriodicidad: {text: "periodo", value: 'periodo' },
        width: 500,
        content: '',
        disabledButton: false,
        disabledButton2: false,
        spinSettings: { position: "Right", width: 20 },
        relevancia: ["Baja", "Media", "Alta"],
        periodicidad: ["Permanente", "Unica Vez", "Periodico"],
        reportingAuthorities: [],
        reportingAuthority: null,
        reportingAuthorityName: null,
        showReportingAuthorityName: false,
        currentTenant: localStorage.getItem('TID') || null,
        isPublicReportingAuthority: false,
    };
  },
  methods: {
    validateSubmit: function () {
      this.disabledButton = true;
      this.$refs.progressBtnFormUsers.enable;
      this.data.currentTenant = localStorage.getItem('TID') || null;
      this.data.isPublicReportingAuthority = this.isPublicReportingAuthority;
      this.data.reportingAuthorityName = this.reportingAuthorityName;
      axios.post("/auth/regulatoryAffairs/editCompliance", {
          data: this.data,
        }).then((response) => {
            Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
          Vue.prototype.$eventHub.$emit("closeSidebarClick");
          this.disabledButton = false;
          Vue.prototype.$eventHub.$emit("onGetCompliance");
        }).catch((error) => {
            this.disabledButton = false;
            Vue.prototype.$eventHub.$emit('showToastNotification', {
                status: 'error',
                message: error.response.data.message || 'Error al procesar la solicitud.'
            });
        });
    },
    getListPeriodicidad : function (){
        axios.post('/auth/compliance/getListPeriodicidad',)
            .then((response) => {
                this.listPeriodicidad = response.data;
        });
    },
    onAddRule: function (data) {
      Vue.prototype.$eventHub.$emit("toggleSidebarClick","Asociar Norma","add-rule-compliance",data,"mw-100");
    },
    addDate: function () {
      this.data.fechas.push({ fecha_cumplimiento: "" });
    },

    onRuleEdit: function (data) {
        Vue.prototype.$eventHub.$emit("toggleSidebarClick","Editar norma","edit-rule",data);
    },
    onUnpin: function (data) {
        axios.post("/auth/regulatoryAffairs/onUnpinRule", {
                data: {norma_id: data.id,cumplimiento_id: data.cumplimiento_id,},
            }).then((response) => {
                Vue.prototype.$eventHub.$emit("onGetCompliance");
                Vue.prototype.$eventHub.$emit("closeSidebarClick");
            }).catch((error) => {
                this.disabledButton = false;
            });
    },
    /* Envio de notificación */
    alertSubmit: function (){
        this.disabledButton2 = true;
        axios.post("/auth/regulatoryAffairs/sendNotification", {
          content: this.content,
          compliance_id: this.data.id
        }).then((response) => {
            Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
          Vue.prototype.$eventHub.$emit("closeSidebarClick");
          this.disabledButton2 = false;
        }).catch((error) => {
          this.disabledButton2 = false;
        });
    },

    deleteDate: function (key) {
      this.data.fechas.splice(key, 1);
    },

    /**
     * Loader
     */
    progress: function () {
      if (this.disabledButton == false) {
        this.$refs.progressBtnFormUsers.stop();
      }
    },
    getReportingAuthorities: function () {
            const TID = localStorage.getItem('TID') || null;
            axios.get('/reporting-authorities', { params: { TID } })
                .then((response) => {
                    this.reportingAuthorities = response.data;
                });
    }
  },
  created() {
      this.getListPeriodicidad();
  },
  mounted() {
    this.getReportingAuthorities();
  }
};
</script>